module.exports = __webpack_public_path__ + "static/img/zgrb.d6bb6052.png";